import React, { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { Field } from 'react-final-form';
import Dropdown, { DropdownOption } from 'src/common/components/DropdownDS22';
import Label from 'src/common/components/Label';
import { REASON_FIELD, SNOOZE_REASONS } from 'src/admin/common/components/SnoozeModal/constants';
import styles from './ReasonField.module.scss';

const {
  MAINTENANCE, SEASONAL, OUT_OF_OFFICE, OTHER,
} = SNOOZE_REASONS;

const convertToString = (value: number | null): string => value.toString();
const convertToNumber = (value: string | null): number => +value;

const ReasonField: FC = () => {
  const [t] = useTranslation('admin-listings');
  const options: DropdownOption[] = useMemo(() => [
    {
      id: convertToString(MAINTENANCE),
      dropdownLabel: t('snooze-listing--reason-option-maintenance'),
    },
    {
      id: convertToString(SEASONAL),
      dropdownLabel: t('snooze-listing--reason-option-seasonal'),
    },
    {
      id: convertToString(OUT_OF_OFFICE),
      dropdownLabel: t('snooze-listing--reason-option-out-of-office'),
    },
    {
      id: convertToString(OTHER),
      dropdownLabel: t('snooze-listing--reason-option-other'),
    },
  ], [t]);

  return (
    <div className={styles.root}>
      <Label label={t('snooze-listing--reason-label')} />
      <Field name={REASON_FIELD}>
        {({ input: { onChange, value } }) => (
          <Dropdown
            selectedValue={options.find(({ id }) => id === convertToString(value))}
            options={options}
            onChange={(option) => onChange(convertToNumber(option.id))}
            instructionLabel={t('snooze-listing--reason-label-instruction')}
            variant="overlap"
            fullWidth
          />
        )}
      </Field>
    </div>
  );
};

export default ReasonField;
